export default {
    topicStatuses: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/topicStatus/state.js